import BaseModelCorrectionLog from "@/models/BaseModelCorrectionLog.js";

export const CorrectionLogToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
		id: "btnBackToCorrectionReport",
		type: "button",
		text: "Back To Correction Report",
		showIcon: "toolbar",
		icon: "undo",
		attributes: {
			"class": "float-right-btn btn btn-secondary",
			"style": "background: #fff;"
		}
	}]

}

export const IssuanceCorrectionLogConfig = {
	list: BaseModelCorrectionLog.list,
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: true
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'Business Event',
			width: 180,
			hidden: false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program',
			width: 200,
			hidden: false,
			readOnly: true
		},
		ReceiverId: {
			class: 'lookup',
			dataName: 'ReceiverId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true
		},
		ReceiverFullName: {
			class: 'lookup',
			dataName: 'Receiver/FullName',
			type: 'string',
			title: 'Partner Name',
			width: 180,
			hidden: false,
			readOnly: true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 150,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 150,
			hidden: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'Unit Pool',
			width: 150,
			hidden: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Unit',
			width: 120,
			hidden: false,
			template: '#=kendo.format("{0:n2}", Unit )#',
		},
		TransactionDate: {
			class: 'value',
			dataName: 'TransactionDate',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 120,
			hidden: false
		},
		CorrectionDate: {
			class: 'value',
			dataName: 'CorrectionDate',
			type: 'date',
			title: 'Correction Date',
			filterable: true,
			width: 200,
			hidden: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true
		},
		BatchGUID: {
			class: 'value',
			dataName: 'BatchGUID',
			type: 'string',
			title: 'Batch Id',
			width: 100,
			hidden: true
		}
	},
	grid: {
		gridId: "CorrectionLogGrid",
		height: 500,
		groupable: true,
		checkbox: true,
		actionsColumnWidth: 120
	}
};
export const TransferCorrectionLogConfig = {
	list: BaseModelCorrectionLog.list,
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: true
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'Business Event',
			width: 180,
			hidden: false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program',
			width: 150,
			hidden: false,
			readOnly: true
		},
		SenderId: {
			class: 'lookup',
			dataName: 'SenderId',
			type: 'number',
			title: 'Transferor Id',
			width: 100,
			hidden: true
		},
		SenderFullName: {
			class: 'lookup',
			dataName: 'Sender/FullName',
			type: 'string',
			title: 'Transferor',
			width: 150,
			hidden: false,
			readOnly: true
		},
		ReceiverId: {
			class: 'lookup',
			dataName: 'ReceiverId',
			type: 'number',
			title: 'Transferee Id',
			width: 100,
			hidden: true
		},
		ReceiverFullName: {
			class: 'lookup',
			dataName: 'Receiver/FullName',
			type: 'string',
			title: 'Transferee',
			width: 150,
			hidden: false,
			readOnly: true
		},
		NonAffiliateTransfer:{
			class: 'value',
			dataName: 'NonAffiliateTransfer',
			type: 'boolean',
			title: 'NonAffiliateTransfer',
			width: 100,
			hidden: true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 150,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 150,
			hidden: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'Unit Pool',
			width: 150,
			hidden: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Unit',
			width: 120,
			hidden: false,
			template: '#=kendo.format("{0:n2}", Unit )#',
		},
		TransactionDate: {
			class: 'value',
			dataName: 'TransactionDate',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 200,
			hidden: false
		},
		CorrectionDate: {
			class: 'value',
			dataName: 'CorrectionDate',
			type: 'date',
			title: 'Correction Date',
			filterable: true,
			width: 200,
			hidden: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true
		},
		BatchGUID: {
			class: 'value',
			dataName: 'BatchGUID',
			type: 'string',
			title: 'Batch Id',
			width: 100,
			hidden: true
		}
	},
	grid: {
		gridId: "CorrectionLogGrid",
		height: 500,
		groupable: true,
		checkbox: true,
	}
};
export const VestingCorrectionLogConfig = {
	list: BaseModelCorrectionLog.list,
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: true
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'Business Event',
			width: 180,
			hidden: false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			title: 'Program',
			width: 200,
			hidden: false,
			readOnly: true
		},
		ReceiverId: {
			class: 'lookup',
			dataName: 'ReceiverId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true
		},
		ReceiverFullName: {
			class: 'lookup',
			dataName: 'Receiver/FullName',
			type: 'string',
			title: 'Partner',
			width: 180,
			hidden: false,
			readOnly: true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 150,
			hidden: false
		},
		UnitType: {
			class: 'choice',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 150,
			hidden: false
		},
		UnitPool: {
			class: 'choice',
			dataName: 'UnitPool',
			type: 'string',
			title: 'UnitPool',
			width: 150,
			hidden: false
		},
		Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'number',
			title: 'Vesting Base Units',
			width: 120,
			hidden: true,
			template: '#=kendo.format("{0:n2}", Unit )#',
		},
		VestStartDate: {
			class: 'value',
			dataName: 'VestStartDate',
			type: 'date',
			title: 'Vesting Start Date',
			filterable: true,
			width: 220,
			hidden: true
		},
		Year: {
			class: 'value',
			dataName: 'Year',
			type: 'number',
			title: 'Vesting Year',
			filterable: true,
			width: 180,
			hidden: true
		},
		VestedDate: {
			class: 'value',
			dataName: 'VestedDate',
			type: 'date',
			title: 'Last Vesting Date',
			filterable: true,
			width: 180,
			hidden: false
		},
		Percentage: {
			class: 'value',
			dataName: 'Percentage',
			type: 'percent',
			format: '{0:p}',
			title: 'Vested Percentage',
			filterable: true,
			width: 180,
			hidden: false
		},
		VestedUnit: {
			class: 'value',
			dataName: 'VestedUnit',
			type: 'number',
			title: 'Vested Unit',
			filterable: true,
			width: 180,
			hidden: false
		},
		SpecialArrangement: {
			class: 'value',
			dataName: 'SpecialArrangement',
			type: 'string',
			title: 'Special Vesting',
			filterable: true,
			width: 180,
			hidden: false
		},
		CorrectionDate: {
			class: 'value',
			dataName: 'CorrectionDate',
			type: 'date',
			title: 'Correction Date',
			filterable: true,
			width: 180,
			hidden: false
		},
		TransactionDate: {
			class: 'value',
			dataName: 'TransactionDate',
			type: 'date',
			title: 'Date',
			filterable: true,
			width: 100,
			hidden: true
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true
		},
		BatchGUID: {
			class: 'value',
			dataName: 'BatchGUID',
			type: 'string',
			title: 'Batch Id',
			width: 100,
			hidden: true
		}
	},
	grid: {
		gridId: "CorrectionLogGrid",
		height: 500,
		groupable: true,
		checkbox: true,
	}
}